<div
	class="systemWarningContainer"
	id="systemShutdownWarning"
>
	<mat-icon
		fontIcon="fa-exclamation-triangle"
		fontSet="fas"
		inline
	/>
	<span>
		{{ T.SYSTEM_SHUTDOWN_WARNING | translate }}
		<sim-countdown-timer
			(onTimeUp)="timeUp.emit()"
			[seconds]="nextSystemShutdown()"
			format="mm:ss"
		/>
	</span>

	<sim-button
		(onClick)="cancelShutdown.emit()"
		[icon]="{
			fontSet: 'fal',
			fontIcon: 'fa-times',
			themeColor: 'white',
		}"
		[label]="T.SYSTEM_SHUTDOWN_CANCEL"
		color="warn"
	/>
</div>
